module.exports = __webpack_public_path__ + "static/media/data_analytics.5d1a80a7.svg";